import React from "react";

const ChapterQuizPromptScreen = ({ 
  handleQuiz, 
  handleExit, 
  cancelQuiz, 
  quizbutton,
  setShowCourseExitModal,
  setShowQuizExitModal
}) => {
  return (
    <div className="d-flex justify-content-center">
      <div className="entry-screen text-align-center position-relative">
        {/* Beautiful Loader Overlay */}
        {quizbutton && (
          <div 
            className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center"
            style={{
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
              zIndex: 1000,
              borderRadius: '8px',
              backdropFilter: 'blur(3px)'
            }}
          >
            {/* Modern animated spinner with layered effect */}
            <div className="position-relative mb-4">
              <div className="spinner-border" style={{ 
                width: '4rem', 
                height: '4rem', 
                borderColor: '#0BA8CF',
                borderRightColor: 'transparent',
                borderWidth: '4px'
              }} role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              {/* Pulsing ring effect */}
              <div className="position-absolute top-50 start-50 translate-middle">
                <div className="spinner-border" style={{ 
                  width: '5rem', 
                  height: '5rem',
                  borderColor: '#0BA8CF',
                  borderRightColor: 'transparent',
                  borderWidth: '4px',
                  opacity: 0.25
                }}></div>
              </div>
            </div>
            
            {/* Elegant loading text */}
            <div className="loading-content">
              <p className="mb-2 fs-5 fw-bold" style={{ color: '#0BA8CF' }}>
                Loading Quiz Question...
              </p>
              <p className="mb-3 text-muted" style={{ fontSize: '0.9rem' }}>
                Please wait while we prepare your question
              </p>
              <div className="d-flex justify-content-center gap-2">
                <div className="rounded-circle" style={{ 
                  width: '10px', 
                  height: '10px', 
                  backgroundColor: '#0BA8CF',
                  animation: 'pulse 1.4s ease-in-out infinite both',
                  animationDelay: '-0.32s'
                }}></div>
                <div className="rounded-circle" style={{ 
                  width: '10px', 
                  height: '10px', 
                  backgroundColor: '#0BA8CF',
                  animation: 'pulse 1.4s ease-in-out infinite both',
                  animationDelay: '-0.16s'
                }}></div>
                <div className="rounded-circle" style={{ 
                  width: '10px', 
                  height: '10px', 
                  backgroundColor: '#0BA8CF',
                  animation: 'pulse 1.4s ease-in-out infinite both'
                }}></div>
              </div>
            </div>
          </div>
        )}

        <div className="logoText">
          <h3>Chapter <span>Quiz</span></h3>
        </div>
        <strong className="d-block text-primary-s fw-normal py-2">
          <i className="fa fa-graduation-cap me-1"></i>You will now be presented with a question from this chapter. Select Next when you are ready to answer this question.
        </strong>
        <br />
        <h2 className="fw-bold text-primary-s">
          If you are not ready to answer the question. Select Back to review the chapter again or Exit to leave the course.
        </h2>
        <div className="row">
          <div className="col-lg-2 mt-4">
            <button 
              onClick={() => setShowCourseExitModal(true)}
              className="btn btn-secondary-s mb-3 btn-md w-90 text-white"
              disabled={quizbutton}
              style={{
                opacity: quizbutton ? 0.6 : 1,
                cursor: quizbutton ? 'not-allowed' : 'pointer'
              }}
            >
              <i className="fa fa-arrow-left fs-12"></i> Exit
            </button>
          </div>
          <div className="col-lg-10 col-md-12">
            <div className="d-flex justify-content-between mt-4 gap-4">
              <button
                className="btn mb-4 btn-secondary-s text-white btn-md w-50 rounded-2"
                onClick={cancelQuiz}
                disabled={quizbutton}
                style={{
                  opacity: quizbutton ? 0.6 : 1,
                  cursor: quizbutton ? 'not-allowed' : 'pointer'
                }}
              >
                <i className="fa fa-angle-left me-1"></i> Back
              </button>
              <button
                className="btn mb-4 course-start btn-primary-s text-white btn-md w-50 rounded-2"
                disabled={quizbutton}
                onClick={handleQuiz}
              >
                {quizbutton ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Loading...
                  </>
                ) : (
                  <>
                    NEXT <i className="fa fa-angle-right ms-1"></i>
                  </>
                )}
              </button>
            </div>
          </div>
        </div>

        {/* CSS Animation */}
        <style dangerouslySetInnerHTML={{
          __html: `
            @keyframes pulse {
              0%, 80%, 100% {
                transform: scale(0.8);
                opacity: 0.5;
              }
              40% {
                transform: scale(1.2);
                opacity: 1;
              }
            }
            
            .spinner-border {
              animation: spin 1s linear infinite;
            }
            
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `
        }} />
      </div>
    </div>
  );
};

export default ChapterQuizPromptScreen;
